<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 16H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7v5a1 1 0 0 0 1 1h5v9a1 1 0 0 1-1 1ZM2 11v1.5h7V11H2Zm0-3v1.5h10V8H2Z" transform="translate(1)" fill="currentColor"/><path d="M14.002 6.001h-5a1 1 0 0 1-1-1v-5l6 6Z" opacity=".45" transform="translate(1)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering171',
});
</script>
